export default "__VITE_ASSET__LH360qrF__"